<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0 mb-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row">

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm" @keydown.enter="() => applyFilters()" :placeholder="helper.trans('labels.name')" v-model="requestDTO.query">
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="radio" v-model="requestDTO.periodType" value="all" class="btn-check" name="options-outlined" id="group-all" autocomplete="off" checked>
                      <label class="btn btn-sm btn-outline-dark text-capitalize" for="group-all"> {{helper.trans('labels.all')}}</label>
                      <input type="radio" v-model="requestDTO.periodType" value="new" class="btn-check" name="options-outlined" id="group-new" autocomplete="off">
                      <label class="btn btn-sm btn-outline-dark ms-2" for="group-new">{{helper.trans('labels.new_traders')}}</label>
                      <input type="radio" v-model="requestDTO.periodType" value="deactivated" class="btn-check" name="options-outlined" id="group-deactivated" autocomplete="off">
                      <label class="btn btn-sm btn-outline-dark ms-2" for="group-deactivated">{{helper.trans('labels.deactivated_traders')}}</label>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.fromDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.from_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.toDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.to_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>


                <div  class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <TeamLeadMultiselect :multiple="false" v-model="teamLeadFilter"></TeamLeadMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="form-check small mb-0  mt-1">
                      <input class="form-check-input" v-model="requestDTO.isActive" true-value="y"  type="checkbox" value="" id="isActive">
                      <label class="form-check-label" for="isActive">
                        {{ helper.trans('labels.only_active')}}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>
              </div>
              <div class="row mt-3" >
                <div class="col text-end">
                  <button type="button" @click.prevent="() => downloadReport()" class="btn btn-link btn-sm m-0 p-0 text-capitalize-first">
                    <i class="fa-solid fa-download"></i> {{ helper.trans('labels.download_report') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row m-4 mb-0 mt-0">
      <div class="col-sm-12">
        <div class="card card-body mb-0">
          <div class="overflow-auto">
            <table class="table table-bordered align-middle text-left text-nowrap position-relative">
              <thead>
              <tr class="bg-light">
                <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.name') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.email') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.reg_date') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.is_blocked') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.block_reason') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.blocked_at') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.first_deal_at') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.last_deal_at') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.completed_turnover_amount_usdt') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.balance_usdt') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.frozen_balance_usdt') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.insurance_amount_usdt') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.insurance_limit_usdt') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.last_deposit_at') }}</th>
                <th class="text-capitalize-first">{{ helper.trans('labels.last_withdrawal_at') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in response.items">
                <td>{{item.id}}</td>
                <td>{{item.name}}</td>
                <td>{{item.email}}</td>
                <td>{{dateHelper.format(item.regDate)}}</td>
                <td>{{item.isBlocked}}</td>
                <td>{{item.blockReason}}</td>
                <td>{{dateHelper.format(item.blockedAt)}}</td>
                <td>{{dateHelper.format(item.firstDealAt)}}</td>
                <td>{{dateHelper.format(item.lastDealAt)}}</td>
                <td>{{numberFormatter.formatNumber(item.completedTurnoverAmountUsdt)}}</td>
                <td>{{numberFormatter.formatNumber(item.balanceAmountUsdt)}}</td>
                <td>{{numberFormatter.formatNumber(item.frozenAmountUsdt)}}</td>
                <td>{{numberFormatter.formatNumber(item.insuranceAmountUsdt)}}</td>
                <td>{{numberFormatter.formatNumber(item.insuranceLimitUsdt)}}</td>
                <td>{{dateHelper.format(item.lastDepositAt)}}</td>
                <td>{{dateHelper.format(item.lastWithdrawalAt)}}</td>
              </tr>
              </tbody>
            </table>

            <b-pagination
              v-if="response.totalCount > response.items.length"
              v-model="page"
              :total-rows="response.totalCount"
              :per-page="response.limit"
              :limit="20"
              @update:modelValue="load()"
              prev-text="Back"
              next-text="Next"
              align="start"
              first-number
              hide-goto-end-buttons
              hide-ellipsis
            ></b-pagination>
          </div>
        </div>

      </div>
    </div>

  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";
import {debounce, helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import {UserRole} from "@/models/enum/UserRole";
import {DealStatus} from "@/models/enum/DealStatus";
import Multiselect from "vue-multiselect";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import TeamLeadMultiselect from "@/components/TeamLeadMultiselect.vue";
import UserDTO from "@/models/UserDTO";
import {DatePicker} from "v-calendar";

const notification = useNotification()

export default defineComponent({
  components: {
    DatePicker,
    TeamLeadMultiselect,
    PayMethodIcon,
    TraderMultiselect,
    Multiselect,
    LoaderWrapper,
    CopyButton,
    BPagination,
  },
  setup() {
    const defaultRequestDTO = {
      fromDate: null,
      toDate: null,
      teamLeadId: null,
      isActive: null,
      periodType: null,
    };

    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      teamLeadFilter: null as UserDTO|null,
      page: 1,
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<any>,
      requestDTO: {
        ...defaultRequestDTO
      } as any
    });



    const clearFilters = async () => {
      state.teamLeadFilter = null;
      state.requestDTO = {
        ...defaultRequestDTO
      }
    }

    const load = async () => {
      loader.value?.show()
      try {
        state.response.offset = state.response.limit * (state.page - 1)
        state.requestDTO.teamLeadId = state.teamLeadFilter?.id
        state.response = await api.call.statistic.traders(state.response,
          {
            ...state.requestDTO,
            fromDate: dateHelper.toUTC(state.requestDTO.fromDate),
            toDate: dateHelper.toUTC(state.requestDTO.toDate)
          }

        );
      } finally {
        loader.value?.hide()
      }
    }

    const applyFilters = async () => {
      load()
    }

    const downloadReport = async () => {
      loader.value?.show()
      state.requestDTO.teamLeadId = state.teamLeadFilter?.id

      try {
        const data = await api.export('traders_stat', {
          ...state.requestDTO,
          fromDate: dateHelper.toUTC(state.requestDTO.fromDate),
          toDate: dateHelper.toUTC(state.requestDTO.toDate),
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(new Blob([data]));
        link.href = url
        link.setAttribute('download', 'report.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } finally {
        loader.value?.hide()
      }
    }

    onMounted(() => {
      load()
    });

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      isOperator: computed(() => store.getters.isOperator),
      isAdmin: computed(() => store.getters.isAdmin),
      loader,
      dateHelper,
      numberFormatter,
      helper,
      clearFilters,
      UserRole,
      DealStatus,
      applyFilters,
      store,
      load,
      downloadReport,
    }
  }
})
</script>
